import React, { Component } from "react";
// import {Row, Grid, Col} from 'react-bootstrap';
import { List, Segment } from "semantic-ui-react";
import { setDateFormat,getSelectedOffice } from "../../../../Global/CustomFunctions";

class personalInfoView extends Component {
  constructor(props, context) {
    super(props, context);
    this.state = {          
      Hide:true
    };    
  }
  componentWillMount(){
      let SelectedOffice=getSelectedOffice();
      let res=(SelectedOffice.Country?.toLocaleLowerCase().indexOf("uk")>0)?true:false;
      this.setState({Hide:res});
    }
  render() {   
    let data=this.props.data;
    let Hide=this.state.Hide;
    return (
      <Segment.Group className="BasicInfoCnt">
        <Segment basic>
          <h1 className="textStyleHeading">Personal Information</h1>
          <List className="userDataList">
            <List.Item>
              <label className="titleLabel">Father/Husband Name:</label>
              <label>
                {data.FatherOrHusbandName}
              </label>
            </List.Item>
            <List.Item>
              <label className="titleLabel">Date of Birth:</label>
              <label>
                {setDateFormat(data.DOB).format("LL")}
              </label>
            </List.Item>

            <List.Item>
              <label className="titleLabel">Marital Status:</label>
              <label>
                {data.MatrialStatus}
              </label>
            </List.Item>

            <List.Item>
              <label className="titleLabel">Gender:</label>
              <label>
                {data.Gender}
              </label>
            </List.Item>

            <List.Item>
              <label className="titleLabel">Level:</label>
              <label>
                {data.Level}
              </label>
            </List.Item>

            <List.Item>
              <label className="titleLabel">Current Salary:</label>
              <label>
                {data.CurrentSalary}
              </label>
            </List.Item>

            <List.Item className={`${Hide ? "hide" : ""}`} >
              <label className="titleLabel">Total Experience:</label>
              <label>
                {data.TotalExperience}
              </label>
            </List.Item>

            <List.Item>
              <label className="titleLabel">Employee Status:</label>
              <label>
                {data.EmployeeStatus}
              </label>
            </List.Item>
          </List>
        </Segment>
      </Segment.Group>
    );
  }
}

export default personalInfoView;
